import React, { useContext, useEffect, useState } from "react"
import { client } from "../../.."
import { getGroupListForOrg } from "../../../api"
import { Loader } from "../../../components/Loader"
import { showErrorMessage } from "../../../helper/helper"
import { buildGroups, GroupModel } from "../../../models/organisation/GroupModel"
import { MarketContext, PriceForOrganisation } from "../MyPrices"
import { GroupPriceRow } from "./GroupPriceRow"


type Props = {
    info: PriceForOrganisation
}

export function GroupPriceTab(props: Props) {

    const [groups, setGroups] = useState<GroupModel[]>([])
    const [loading, setLoading] = useState(false)

    const marketData = useContext(MarketContext)

    useEffect(() => {
        if (groups.length === 0) {
            setLoading(true)
            client.query({
                query: getGroupListForOrg,
                variables: {
                    organisationId: props.info.org.id
                }
            }).then((data) => {
                let groups = buildGroups(data.data.groups)
                setGroups(groups)
            }).catch(e => {
                showErrorMessage(e.message)
            }).finally(() => {
                setLoading(false)
            })
        }
        // eslint-disable-next-line
    }, [])

    return (
        <div style={{minHeight:loading ? "80px": "40px"}}>
            {
                !loading && groups.length > 0 && groups.map(g => {
                    return <GroupPriceRow key={g.id} group={g} price={props.info.price.getTodayPrice(marketData.marketDay)} />
                })
            }
            {
                !loading && groups.length === 0 &&
                <p>No Groups declared</p>
            }
            <Loader isLoading={loading} fullScreen={false} />
        </div>
    )
}